import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@env';
import { SmsRichPeriodStatistics, SmsRichUserStatistic } from '@models/sms/rich-sms-details';
import { RichSmsDetailsService } from '@services/rich-sms-details.service';
import { ChartDataset, ChartOptions, ChartType, TooltipItem } from 'chart.js';
import moment from 'moment';
// import { Color, Label } from 'ng2-charts';

@Component({
  selector: 'wsb-click-statistics',
  templateUrl: './click-statistics.component.html',
  styleUrls: ['./click-statistics.component.scss'],
  standalone: false
})
export class ClickStatisticsComponent implements OnInit {
  @Input() uuidMessage: string;
  threeDayData;
  clicksStats: SmsRichUserStatistic = new SmsRichUserStatistic();

  public lineChartThreeDayLegend = false;
  public lineChartThreeDayType: ChartType = 'bar';
  public lineChartThreeDayOptions?: ChartOptions;
  public lineChartThreeDayData: ChartDataset[] = [];
  public lineChartThreeDayLabels: string[] = [];

  public lineChartPerDayLegend = false;
  public lineChartPerDayType: ChartType = 'line';
  public lineChartPerDayOptions?: ChartOptions;
  public lineChartPerDayData: ChartDataset[] = [];
  public lineChartPerDayLabels: string[] = [];

  constructor(private richSmsDetailService: RichSmsDetailsService) {}

  ngOnInit(): void {
    this.updateAxes();
    this.getThreeDayData(this.uuidMessage);

    this.getClicksStats(this.uuidMessage);
  }

  getThreeDayData(uuid?) {
    this.richSmsDetailService.getSmsRichPeriodStatistics(uuid).subscribe(statistics => {
      this.getPerDayStats(statistics);

      const fromDate = moment()
        .subtract(3, 'days')
        .format('YYYY-MM-DD');

      const data = statistics.data.filter(x => x.day >= fromDate).map(x => x.count);

      const labels = statistics.data.filter(x => x.day >= fromDate).map(x => x.label + ' ' + x.sliceLabel);

      this.lineChartThreeDayData = [
        {
          data,
          label: 'Three day data',
          backgroundColor: environment.chartsColorPalette[0],
          borderColor: environment.chartsColorPalette[0],
          pointBorderColor: environment.chartsColorPalette[1],
          pointHoverBorderColor: environment.chartsColorPalette[1]
        }
      ];
      this.lineChartThreeDayLabels = [...labels];
    });
  }

  getPerDayStats(statistics: SmsRichPeriodStatistics) {
    const datesKeys = new Set(statistics.data.map(data => data.day));
    const values = new Map<string, number>();
    this.lineChartPerDayLabels = [...datesKeys];
    datesKeys.forEach(day => {
      const clicksCount = statistics.data.filter(x => x.day === day).reduce((acc, curr) => acc + curr.count, 0);
      values.set(day, clicksCount);
    });
    this.lineChartPerDayData = [
      {
        data: [...values.values()],
        label: 'Three day data',
        backgroundColor: 'rgba(0, 0, 0 , 0.0)',
        borderColor: environment.chartsColorPalette[0],
        pointBorderColor: environment.chartsColorPalette[0],
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
      }
    ];
  }

  getClicksStats(uuid?) {
    this.richSmsDetailService.getSmsRichUserStatistics(uuid).subscribe(statistics => {
      this.clicksStats = statistics;
    });
  }

  private updateAxes(): void {
    this.lineChartPerDayOptions = {
      elements: {
        line: {
          tension: 0
        }
      },
      plugins: {
        tooltip: {
          mode: 'index',
          callbacks: {
            title(context: TooltipItem<ChartType>[]): string | string[] {
              return `${context[0].label} - ${context[0].raw}`;
            },
            label(context: TooltipItem<ChartType>): string | string[] {
              return undefined;
            }
          }
        }
      },
      responsive: true,
      scales: {
        y: {
          beginAtZero: true,
          ticks: { stepSize: 1, maxTicksLimit: 10 }
        },
        x: {
          grid: { color: 'rgba(255,0,0,0.0)' }
        }
      }
    };

    this.lineChartThreeDayOptions = {
      scales: {
        y: {
          beginAtZero: true,
          ticks: { stepSize: 1, maxTicksLimit: 10 }
        },
        x: {
          ticks: {
            maxRotation: 0,
            minRotation: 0,
            autoSkip: true
          }
        }
      }
    };
  }
}
